/* eslint max-len: 0 */
const icon = require('vue-svgicon')
icon.register({
  'reset': {
    viewBox: '0 0 24 24',
    data: `<path d="M13.25,18.01a6,6,0,1,0-6-6v3.1l-1.8-1.8-.7.7,3,3,3-3-.7-.7-1.8,1.8v-3.1a5,5,0,1,1,5,5Z" style="fill-rule:evenodd"/>`
  }
})
